import School from "./School";
import Client from "./Client";
import Semester from "./Semester";
import { formatDate } from "../utils/format-utils";

export default class ClientSchool {
    clientSchoolId?: number | null;
    legacyClientSchoolId?: number | null;
    clientId?: number | null;
    client?: Client | null;
    schoolId?: number | null;
    school?: School | null;
    semesterId?: number | null;
    semester?: Semester | null;
    effectiveDate?: Date | null;
    endDate?: Date | null;
    subSchoolId?: number | null;
    subSchool?: School | null;
    subSchoolEffectiveDate?: Date | null;
    subSchoolEndDate?: Date | null;
     constructor (params: ClientSchool = {} as ClientSchool) {
        let {
            clientSchoolId = 0,
            legacyClientSchoolId = 0,
            clientId = 0,
            client = null,
            schoolId = 0,
            school = null,
            semesterId = null,
            semester = null,
            effectiveDate = null,
            endDate = null,
            subSchoolId = null,
            subSchool = null,
            subSchoolEffectiveDate = null,
            subSchoolEndDate = null
          } = params;
          this.clientSchoolId = clientSchoolId;
          this.legacyClientSchoolId = legacyClientSchoolId;
          this.clientId = clientId;
          this.client = client && new Client(client);
          this.schoolId = schoolId;
          this.school = school && new School(school);
          this.semesterId = semesterId;
          this.semester = semester && new Semester(semester);
          this.effectiveDate = effectiveDate && new Date(effectiveDate);
          this.endDate = endDate && new Date(endDate);
          this.subSchoolId = subSchoolId;
          this.subSchool = subSchool && new School(subSchool);
          this.subSchoolEffectiveDate = subSchoolEffectiveDate && new Date(subSchoolEffectiveDate);
          this.subSchoolEndDate = subSchoolEndDate && new Date(subSchoolEndDate);
        }
  get formattedEffectiveDate() { return formatDate(this.effectiveDate); }
  get formattedEndDate() { return formatDate(this.endDate); }

}